export default class WellKnown {
    public static IDTYPE_BUYPASS_ID = 40;
    public static IDTYPE_UCI_ID = 1;
    public static IDTYPE_EMIT = 11;
    public static IDTYPE_NIF = 45;
    public static IDTYPE_FIS_CODE = 14;
    public static COUNTRY_NO = 160;
    public static COUNTRY_SE = 205;
    public static COUNTRY_FI = 72;
    public static COUNTRY_FR = 73;
    public static COUNTRY_GE = 80;
    public static COUNTRY_IT = 105;
    public static TRAININGLANES_TRAINING = 0;
    public static TRAININGLANES_RACE = 1;
    public static TEAM_WANG_TOPPIDRETT_OSLO = 15631;
    public static TEAM_DONSKI_VGS = 15163;
    public static TEAM_TRONDHEIM_BIATHLON_TEAM = 14634;
    public static TEAM_MIDTNORGE_SKISKYTING = 16902;
    public static TEAM_INNHERRED = 16901;
    public static TEAM_MERAKER = 15510;
    public static TEAM_NORD_TRONDELAG_SKISKYTTERKRETS = 13959;
    public static TEAM_HEIMDAL_VGS = 13583;
    public static TEAM_STEINKJER_VGS = 13593;
    public static KRETS_NTSSK = 3527;
    public static TEAM_WANG_TOPPIDRETT_ROMERIKE = 15632;
    public static TEAM_GEILO = 14678;
    public static STATIONTYPE_PENALTYLAP = 2;
    public static STATIONTYPE_SHOOTING_CONTROL = 11;
    public static STATIONTYPE_SHOOTING_PRONE = 1;
    public static STATIONTYPE_SHOOTING_STAND = 14;
    public static STATIONTYPE_NORMAL = 0;
    public static FEDERATION_NCF = 13;
    public static FEDERATION_SKIFORBUNDET = 32;
    public static FEDERATION_NSSF = 39;
    public static CONTESTANTSTATUS_REGISTERED = 1;
    public static CONTESTANTSTATUS_LICENSEREGISTERED = 2;
    public static CONTESTANTSTATUS_LICENSEAPPROVED = 100;
    public static CONTESTANTSTATUS_UNKOWNATHLETE = 8;
    public static CONTESTANTSTATUS_UNREGISTERED = 0;
    public static CONTESTANTSTATUS_UNREGISTEREDANDLICENSEAPPROVED = 101;
    public static CONTESTANTSTATUS_UNREGISTEREDANDLICENSEDECLINED = 102;
    public static CONTESTANTSTATUS_CANCELLED = 9;
    public static CONTESTANTSTATUS_SOLDPLACE = 10;
    public static CONTESTANTSTATUS_TRANSFERREDPLACE = 11;
    public static CONTESTANTSTATUS_CAROUSELSIGNUP = 20;
    public static CONTESTANTSTATUS_REFUNDED_DONATED = 51;
    public static CONTESTANTSTATUS_REFUNDED_REQUESTEDREFUND = 52;
    public static CONTESTANTSTATUS_REFUNDED_REQUESTEDTRANSFER = 53;
    public static CONTESTANTSTATUS_REFUNDED_REFUNDED = 54;
    public static CONTESTANTSTATUS_REFUNDED_TRANSFERRED = 55;
    public static CONTESTANTSTATUS_REFUNDED_DONATEDMANUALLY = 56;
    public static ORGANIZERTYPE_REGION = 5;
    public static SPORT_SKIFORBUNDET_LANGRENN = 2;
}
